import { serviceManagementApi, ServicesAutoComplete } from '@api/service-management';
import { subtypeManagementApi } from '@api/deal-subtype-management'
import { useRequest } from './utils';

export function useServicesAutoComplete<T>() {
  const { result, loading, error } = useRequest(
    () => serviceManagementApi.autoCompleteForServices(),
    []
  );
  return { loading, error, master: !loading && result ? result : result };
}

export function useParentServicesAutoComplete<T>(vtr_id: number) {
  const { result, loading, error } = useRequest(
    () => serviceManagementApi.autoCompleteForParentServices(vtr_id),
    [vtr_id]
  );
  return { loading, error, master: !loading && result ? result : result };
}
